import { render } from "./ProductsTable.vue?vue&type=template&id=65c7abe4&scoped=true"
import script from "./ProductsTable.vue?vue&type=script&lang=js"
export * from "./ProductsTable.vue?vue&type=script&lang=js"

import "./ProductsTable.vue?vue&type=style&index=0&id=65c7abe4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c7abe4"]])

export default __exports__